exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Terms {\n    text-align: left;\n  }\n  \n  /* .Terms 안에 들어있는 header */\n  .Terms header {\n    background-color: #282c34;\n    min-height: 100vh;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: center;\n        justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n  }\n  \n  /* .Terms 안에 들어있는 a 태그 */\n  .Terms a {\n    color: #61dafb;\n  }\n\n  .Terms pre {\n    white-space: pre-wrap;\n  }\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./src/components/Terms.css
// module id = 353
// module chunks = 0